import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  organisationId: string;
}

type Result = {};

const options: ApiOptions = {
  method: 'patch',
  urlPath: '/organisation/deactivate',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useOrganisationDeactivateLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useOrganisationDeactivateLazy;
